// extracted by mini-css-extract-plugin
export default {"WhiteLabelFooter":"JAijrnYu","LogoImage":"mNbXUkTJ","WhiteLabelFooterText":"AorgwiIM"};